import type { OAuthProviderId } from "@/services/api";

const LAST_OAUTH_PROVIDER_KEY = "vendor_oauth_last_provider";

export function recordOAuthProviderLogin(provider: OAuthProviderId): void {
  try {
    localStorage.setItem(LAST_OAUTH_PROVIDER_KEY, provider);
  } catch {
    // Private browsing / quota — non-fatal
  }
}

export function getLastOAuthProvider(): OAuthProviderId | null {
  try {
    const value = localStorage.getItem(LAST_OAUTH_PROVIDER_KEY);
    if (value === "discord" || value === "feedforward") {
      return value;
    }
  } catch {
    // ignore
  }
  return null;
}

/** Auto silent SSO only for users who previously signed in with Feedforward */
export function shouldAttemptSilentFeedforwardLogin(): boolean {
  return getLastOAuthProvider() === "feedforward";
}

export function clearOAuthProviderHint(): void {
  try {
    localStorage.removeItem(LAST_OAUTH_PROVIDER_KEY);
  } catch {
    // ignore
  }
}
